import { api } from '../shared/api.js';

/** Photo jointe par le client à une question (multipart, partie `file`) : identifiant à joindre ensuite. */
export async function uploadPortalPhoto(file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file, file.name);
  return (await api('portal.uploadMedia', { body: form })).id;
}
